import { useTranslation } from 'next-i18next';
import { AuthorTagChip } from '@/components/AuthorTagChip';
import { SnailIcon } from '@/icons';
import { cn } from '@/utils/tailwind.util';
type OriginalAuthorProps = {
  authorName: string;
  authorId: string;
  isOfficial: boolean;
  className?: string;
};
export const OriginalAuthor = ({
  authorName,
  authorId,
  isOfficial,
  className
}: OriginalAuthorProps) => {
  const {
    t
  } = useTranslation(['common']);
  return <div className={cn('flex items-center gap-3xs', className)} data-sentry-component="OriginalAuthor" data-sentry-source-file="OriginalAuthor.tsx">
      <div className="flex items-center gap-3xs text-alternative">
        <SnailIcon size="xs" className="hidden tablet-sm:block" data-sentry-element="SnailIcon" data-sentry-source-file="OriginalAuthor.tsx" />
        <SnailIcon size="2xs" className="tablet-sm:hidden" data-sentry-element="SnailIcon" data-sentry-source-file="OriginalAuthor.tsx" />
        <span className="text-caption-lg-medium tablet-sm:text-body-sm-medium">
          {t('quizDetail.originQuizAuthor')}
        </span>
        <span>-</span>
      </div>
      <AuthorTagChip authorName={authorName} isOfficial={isOfficial} authorHashId={authorId} data-sentry-element="AuthorTagChip" data-sentry-source-file="OriginalAuthor.tsx" />
    </div>;
};